import React, { FC, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAptorApi } from '../../../../../../Api';
import { IGridQueryRequest } from '../../../../../../Api/AptorApi';
import { CompanyUnits, ICompanyUnit } from '../../CompanyUnits.List';

export const RequirementCompanyUnits: FC<{ reqId: number }> = ({ reqId }) => {
  const { api } = useAptorApi();
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/law-portal/settings')
    ? `/law-portal/settings/other-requirements/${reqId}`
    : `/organization/law-portal/other-requirements/${reqId}`;
  
  const dataFetcher = useCallback(
    async (request: IGridQueryRequest) => {
      const result = await api.searchRequirementCompanyUnits<ICompanyUnit>(reqId, request);
      return result;
    },
    [reqId, api],
  );

  const remove = useCallback(
    async (id: number) => {
      await api.removeRequirementCompanyUnit(reqId, id);
    },
    [reqId, api],
  );

  return (
    <CompanyUnits
      addLink={`${basePath}/company-units/new`}
      dataFetcher={dataFetcher}
      edit={(id: number) => navigate(`${basePath}/company-units/${id}`)}
      remove={remove}
    />
  );
};